import CardItem from './card-item';

export default CardItem;
